import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreateAddressTypeModel,
  DeleteAddressTypeModel,
  SearchAddressTypeModel,
} from '../../../models/address-type.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class DriverTypeService {
  private baseUrl = environment.baseUrl
  private resource: string = 'especialidades'

  constructor(private httpClient: HttpClient) {}

  public createDriverType(
    model: CreateAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editDriverType(
    model: any,
    // model: EditAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update`,
      model,
    )
  }

  public deleteDriverType(
    model: DeleteAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedDriverType(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listSpecialty(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }

  public getDriverTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedDriverType(
    page: number,
    rows: number = 15,
    model: SearchAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
